import clsx from 'clsx';
import { FunctionComponent, MouseEvent } from 'react';
import { Avatar } from './Avatar';
import styles from './StaffChip.module.scss';

interface StaffChipProps {
    name: string | null;
    imageUrl: string | null;
    className?: string;
    onClickHandler?: (event: MouseEvent<HTMLDivElement>) => void;
}

export const StaffChip: FunctionComponent<StaffChipProps> = props => {
    return (
        <div
            className={clsx(styles.container, { [styles.clickable]: props.onClickHandler }, props.className)}
            onClick={props.onClickHandler}
        >
            <Avatar imageUrl={props.imageUrl} />
            <span className={styles.name}>{props.name ?? 'Unassigned'}</span>
        </div>
    );
};

export default StaffChip;
